<app-navbar *ngIf="!isAdmin"></app-navbar>

<main
    [class.admin-layout]="isAdmin"
    [class.page-content]="!isAdmin">

    <router-outlet></router-outlet>

</main>

<app-footer *ngIf="!isAdmin"></app-footer>